module.exports = __webpack_public_path__ + "static/Deliverect-dbee2dc5c29aa14eb44a90f71c2b8647.jpg";